import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { SellersContainerProps } from "../../../interfaces/containers";
import Sellers from "../../../pages/Profile/Sellers/Sellers";
import { getSellers, cleanSellers, getBranches, cleanBranches } from "../../../actions/profile";

function mapStateToProps(state: SellersContainerProps) {
    return {
        user: state.auth.user,
        sellers: state.profile.sellers,
        branches: state.profile.branches
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getSellers,
        cleanSellers,
        getBranches,
        cleanBranches
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(Sellers);